const organization = [{
  desc: '组织机构新增或修改接口',
  options: {
    url: '/customer/addOrUpdateOrganization',
    method: 'post'
  }
}, {
  desc: '批量组织机构授权和取消授权接口',
  options: {
    url: '/customer/batchUpdateJobNo',
    method: 'post'
  }
}, {
  desc: '组织机构列表接口',
  options: {
    url: '/customer/getOrganization',
    method: 'post'
  }
}, {
  desc: '新版组织机构列表接口',
  options: {
    url: '/customer/queryOrgInfoAndStatistics',
    method: 'post'
  }
}, {
  desc: '新版组织机构列表接口',
  options: {
    url: '/insapi/v3/export/addExportTask',
    method: 'post'
  }
}]
export default organization



// WEBPACK FOOTER //
// ./src/api/organization.js